import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { baseUrlRate, LOCAL_STORAGE_KEY } from "../../../config";
import { path } from "../../../order_managment/constants/apiPath";
import { getUserData } from "../../common/utility/Utils";
import "./rms.css";

const MarkupModule = ({ markData, getApplyMarkUp, setMarkData, value }) => {
  const modeData = ["percentage", "flat"];
  const [originOptions, setOriginOptions] = useState([]);

  const getFreightOrigin = async () => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    let url;
    if (value === "FREIGHT") {
      url = `${baseUrlRate}${path.GET_FREIGHT_ORIGIN}`;
    } else {
      url = url = `${baseUrlRate}${path.GET_IPI_ORIGIN}`;
    }
    axios
      .get(url, {
        headers: header,
      })
      .then((res) => {
        setOriginOptions(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getFreightOrigin();
  }, []);

  return (
    <>
      <Autocomplete
        key={markData.originCode}
        sx={{ width: 300, marginBottom: "1rem" }}
        disablePortal
        id="combo-box-demo"
        options={originOptions}
        renderInput={(params) => <TextField {...params} label="Origin" />}
        onChange={(event, newValue) => {
          setMarkData({ ...markData, originCode: newValue.originCode });
        }}
        getOptionLabel={(option) => option.origin}
      />
      {markData.originCode !== "" ? (
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={0}>
              <Grid item lg={4} md={6} sm={6} xs={6}>
                <Typography>Markup Mode</Typography>
              </Grid>
              <Grid item lg={6} md={4} sm={4} xs={4}>
                <FormControl size="small" fullWidth>
                  <Select
                    value={markData.markUpMode}
                    onChange={(e) => {
                      setMarkData({
                        ...markData,
                        markUpMode: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {modeData.map((item) => {
                      return (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={0}>
              <Grid item lg={4} md={6} sm={6} xs={6}>
                <Typography>Markup Value</Typography>
              </Grid>
              <Grid item lg={6} md={4} sm={4} xs={4}>
                <FormControl size="small" fullWidth>
                  <OutlinedInput
                    type="number"
                    placeholder="Please enter the value"
                    value={markData.markUpMagnitude}
                    onChange={(e) => {
                      setMarkData({
                        ...markData,
                        markUpMagnitude: e.target.value,
                      });
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={0}>
              <Grid item lg={4} md={6} sm={6} xs={6}></Grid>
              <Grid item lg={6} md={4} sm={4} xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    getApplyMarkUp();
                    setMarkData({
                      markUpMode: "",
                      markUpMagnitude: "",
                      originCode: "",
                    });
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : null}

      {/* <div className="submit-button">
       
      </div> */}
    </>
  );
};

export default React.memo(MarkupModule);
